import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { ConversionRateEmptyStateType } from "app/pages/website-analysis/TrafficAndEngagement/conversionRateEmptyStateUtils";
import { navigateToSupportedCountry } from "app/pages/website-analysis/TrafficAndEngagement/conversionRateEmptyStateUtils";

import { CONVERSION_RATE_TRANSLATION_KEYS } from "./const";

interface IConversionRateEmptyStateProps {
    emptyStateType: ConversionRateEmptyStateType | null;
}

export const ConversionRateEmptyState = ({ emptyStateType }: IConversionRateEmptyStateProps) => {
    const { translate } = useTranslate();

    const isCountryNotSupported = emptyStateType === "CountryNotSupported";

    return (
        <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            flex="1"
            padding="24px"
            gap="8px"
            data-automation="conversion-rate-empty-state"
        >
            <Text
                fontVariant="subtitle1"
                color={colorsPalettes.carbon[500]}
            >
                {translate(
                    isCountryNotSupported
                        ? CONVERSION_RATE_TRANSLATION_KEYS.emptyCountryNotSupportedTitle
                        : CONVERSION_RATE_TRANSLATION_KEYS.emptyNoDataTitle,
                )}
            </Text>
            {isCountryNotSupported ? (
                <Button
                    onClick={navigateToSupportedCountry}
                    type="outlined"
                    data-automation="conversion-rate-empty-state-worldwide-cta"
                >
                    {translate(CONVERSION_RATE_TRANSLATION_KEYS.emptyCountryNotSupportedCta)}
                </Button>
            ) : (
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon[300]}
                >
                    {translate(CONVERSION_RATE_TRANSLATION_KEYS.emptyNoDataSubtitle)}
                </Text>
            )}
        </Flex>
    );
};
